module.exports = __webpack_public_path__ + "static/media/happy.b008cbef.png";